var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUserActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "url(#paint0_linear_2189_25899)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 31.875C34.6582 31.875 38.4375 28.0957 38.4375 23.4375C38.4375 18.7793 34.6582 15 30 15C25.3418 15 21.5625 18.7793 21.5625 23.4375C21.5625 28.0957 25.3418 31.875 30 31.875ZM37.5 33.75H34.2715C32.9707 34.3477 31.5234 34.6875 30 34.6875C28.4766 34.6875 27.0352 34.3477 25.7285 33.75H22.5C18.3574 33.75 15 37.1074 15 41.25V42.1875C15 43.7402 16.2598 45 17.8125 45H42.1875C43.7402 45 45 43.7402 45 42.1875V41.25C45 37.1074 41.6426 33.75 37.5 33.75Z",
    fill: "#159999"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2189_25899",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5FF6D",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADFF7A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserActive);
export default __webpack_public_path__ + "static/media/icon-user-active.49316a57894b7e042b357862c7e4f19c.svg";
export { ForwardRef as ReactComponent };